import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "../brand/Logo";

export const AuthLayout = ({ children, image = "/img/hero-ejecutivos.jpg", testId }) => (
  <div className="grain relative grid min-h-screen bg-ink text-white lg:grid-cols-2" data-testid={testId}>
    <div className="relative hidden overflow-hidden lg:block">
      <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-60" />
      <div className="absolute inset-0 bg-gradient-to-tr from-ink via-ink/70 to-transparent" />
      <div className="absolute bottom-14 left-14 right-14">
        <p className="font-display text-5xl font-semibold leading-[0.95] tracking-[-0.04em]">
          Conectamos personas.<br />Conectamos empresas.<br /><span className="text-leaf">Creamos oportunidades.</span>
        </p>
      </div>
    </div>
    <div className="relative flex flex-col px-6 py-8 sm:px-14">
      <div className="flex items-center justify-between">
        <Link to="/" data-testid="auth-home"><Logo tone="light" className="h-8" /></Link>
        <Link to="/" className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.12em] text-white/80 hover:text-leaf" data-testid="auth-back">
          <ArrowLeft className="h-4 w-4" /> Sitio
        </Link>
      </div>
      <div className="mx-auto flex w-full max-w-md flex-1 flex-col justify-center py-12">{children}</div>
    </div>
  </div>
);

export const fieldCls = "h-12 rounded-xl border-white/15 bg-white/5 text-white placeholder:text-white/40";

export const Field = ({ id, label, children }) => (
  <div>
    <label htmlFor={id} className="mb-2 block text-sm font-semibold text-white/85">{label}</label>
    {children}
  </div>
);
